// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/mutation-install.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Properties_Content_Content($app_id: uuid!) {
  apps_install(app_id: $app_id) {
    app {
      id
      companies {
        id
        status
      }
    }
  }
}

`